module.exports = __webpack_public_path__ + "static/media/Clock.a31ae1ab.svg";